<template>
  <div>
    <b-form-row>
      <b-col class="mb-2">
        <b-button @click="showResumo" size="sm" variant="success"><i class="fas fa-sync"></i> Atualizar Lista</b-button>
        <b-checkbox class="ml-3" inline size="sm" v-model="exibirCampos" :value="true" :unchecked-value="false">
          Planejado Original
        </b-checkbox>
        <b-checkbox
          class="ml-3"
          inline
          size="sm"
          v-model="exibir2aMoeda"
          :value="true"
          :unchecked-value="false"
          @change="showResumo()"
        >
          2ª Moeda
        </b-checkbox>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <zk-table
          ref="tblWBSSintetico"
          id="tblWBSSintetico"
          :data="resumo"
          :columns="visibleFields"
          border
          show-header
          show-row-hover
          empty-text="Sem estrutura definida"
          :expand-type="false"
          :selection-type="false"
          :row-style="getRowStyle"
          :cell-style="getRowStyle"
        >
          <template slot="vl_planejado" slot-scope="scope">
            {{
              scope.row.vl_planejado
                | formatMoney({
                  decimais: 2,
                  sigla: "",
                  milhar: ".",
                  decimal: ",",
                })
            }}
          </template>
          <template slot="mes_ano" slot-scope="scope">
            <span v-if="scope.row.mes_planejamento == 0"></span>
            <span v-else>{{
              `${String(scope.row.mes_planejamento).padStart(2, "0")}/${scope.row.ano_planejamento}`
            }}</span>
          </template>

          <template slot="vl_planejado_orig" slot-scope="scope">
            {{
              scope.row.vl_planejado_orig
                | formatMoney({
                  decimais: 2,
                  sigla: "",
                  milhar: ".",
                  decimal: ",",
                })
            }}
          </template>
          <template slot="vl_planejado_orig_m2" slot-scope="scope">
            {{
              scope.row.vl_planejado_orig_m2
                | formatMoney({
                  decimais: 2,
                  sigla: "",
                  milhar: ".",
                  decimal: ",",
                })
            }}
          </template>
          <template slot="vl_planejado_m2" slot-scope="scope">
            {{
              scope.row.vl_planejado_m2
                | formatMoney({
                  decimais: 2,
                  sigla: "",
                  milhar: ".",
                  decimal: ",",
                })
            }}
          </template>
          <template slot="vl_pago" slot-scope="scope">
            {{
              scope.row.vl_pago
                | formatMoney({
                  decimais: 2,
                  sigla: "",
                  milhar: ".",
                  decimal: ",",
                })
            }}
          </template>
          <template slot="vl_pago_m2" slot-scope="scope">
            {{
              scope.row.vl_pago_m2
                | formatMoney({
                  decimais: 2,
                  sigla: "",
                  milhar: ".",
                  decimal: ",",
                })
            }}
          </template>
          <template slot="vl_planejado_orig_ac" slot-scope="scope">
            {{
              scope.row.vl_planejado_orig_ac
                | formatMoney({
                  decimais: 2,
                  sigla: "",
                  milhar: ".",
                  decimal: ",",
                })
            }}
          </template>
          <template slot="vl_planejado_orig_m2_ac" slot-scope="scope">
            {{
              scope.row.vl_planejado_orig_m2_ac
                | formatMoney({
                  decimais: 2,
                  sigla: "",
                  milhar: ".",
                  decimal: ",",
                })
            }}
          </template>
          <template slot="vl_planejado_ac" slot-scope="scope">
            {{
              scope.row.vl_planejado_ac
                | formatMoney({
                  decimais: 2,
                  sigla: "",
                  milhar: ".",
                  decimal: ",",
                })
            }}
          </template>
          <template slot="vl_planejado_m2_ac" slot-scope="scope">
            {{
              scope.row.vl_planejado_m2_ac
                | formatMoney({
                  decimais: 2,
                  sigla: "",
                  milhar: ".",
                  decimal: ",",
                })
            }}
          </template>
          <template slot="vl_pago_ac" slot-scope="scope">
            {{
              scope.row.vl_pago_ac
                | formatMoney({
                  decimais: 2,
                  sigla: "",
                  milhar: ".",
                  decimal: ",",
                })
            }}
          </template>
          <template slot="vl_pago_m2_ac" slot-scope="scope">
            {{
              scope.row.vl_pago_m2_ac
                | formatMoney({
                  decimais: 2,
                  sigla: "",
                  milhar: ".",
                  decimal: ",",
                })
            }}
          </template>
          <template slot="vl_saldo_m2_ac" slot-scope="scope">
            {{
              scope.row.vl_saldo_m2_ac
                | formatMoney({
                  decimais: 2,
                  sigla: "",
                  milhar: ".",
                  decimal: ",",
                })
            }}
          </template>
          <template slot="vl_saldo_ac" slot-scope="scope">
            {{
              scope.row.vl_saldo_ac
                | formatMoney({
                  decimais: 2,
                  sigla: "",
                  milhar: ".",
                  decimal: ",",
                })
            }}
          </template>
        </zk-table>
      </b-col>
    </b-form-row>
  </div>
</template>

<script>
import axios from "axios";
import { baseApiUrl, showError } from "@/global";
import { bidbus } from "@/main";

import ZkTable from "vue-table-with-tree-grid";

export default {
  name: "SubTabResumoFinanceiroSintetico",
  components: { ZkTable },
  computed: {
    visibleFields() {
      let _fields = this.campos;
      if (!this.exibirCampos)
        _fields = _fields.filter(
          (field) =>
            field.prop != "vl_planejado_orig" &&
            field.prop != "vl_planejado_orig_ac" &&
            field.prop != "vl_planejado_orig_m2_ac" &&
            field.prop != "vl_planejado_orig_m2"
        );

      if (!this.exibir2aMoeda) _fields = _fields.filter((field) => field.prop.indexOf("_m2") == -1);
      else {
        _fields = _fields.filter(
          (field) =>
            field.prop != "vl_planejado" &&
            field.prop != "vl_planejado_orig" &&
            field.prop != "vl_planejado_orig_ac" &&
            field.prop != "vl_pago_ac" &&
            field.prop != "vl_pago_ac" &&
            field.prop != "vl_pago" &&
            field.prop != "vl_planejado_ac" &&
            field.prop != "vl_saldo_ac"
        );
      }

      if (this.sintetico) {
        _fields = _fields.filter((field) => field.prop != "acoes");
      }

      return _fields;
    },
  },
  props: {
    wbs: { type: Object, required: true },
    acao: { type: String, required: true },
  },
  data: function() {
    return {
      exibir2aMoeda: false,
      exibirCampos: false,
      resumo: [],
      medicoes: [],
      campos: [
        {
          prop: "wbs_id",
          label: "Nível EAP",
          minWidth: "140px",
        },
        {
          prop: "componente",
          label: "Componente",
          minWidth: "200px",
        },
        {
          prop: "mes_ano",
          label: "Mês/Ano Planejamento",
          type: "template",
          template: "mes_ano",
        },
        {
          prop: "vl_planejado_orig",
          align: "right",
          label: "Planejado Antes Fat.",
          type: "template",
          template: "vl_planejado_orig",
        },
        {
          prop: "vl_planejado_orig_m2",
          align: "right",
          label: "Planejado m2 Antes Fat.",
          type: "template",
          template: "vl_planejado_orig_m2",
        },
        {
          prop: "vl_planejado",
          align: "right",
          label: "Planejado",
          type: "template",
          template: "vl_planejado",
        },
        {
          prop: "vl_planejado_m2",
          align: "right",
          label: "Planejado M2",
          type: "template",
          template: "vl_planejado_m2",
        },
        {
          prop: "vl_pago",
          align: "right",
          label: "Realizado",
          type: "template",
          template: "vl_pago",
        },
        {
          prop: "vl_pago_m2",
          align: "right",
          label: "Realizado M2",
          type: "template",
          template: "vl_pago_m2",
        },
        {
          prop: "vl_planejado_orig_ac",
          align: "right",
          label: "Planejado AC Antes Fat.",
          type: "template",
          template: "vl_planejado_orig_ac",
        },
        {
          prop: "vl_planejado_orig_m2_ac",
          align: "right",
          label: "Planejado M2 AC Antes Fat.",
          type: "template",
          template: "vl_planejado_orig_m2_ac",
        },

        {
          prop: "vl_planejado_ac",
          align: "right",
          label: "Planejado AC",
          type: "template",
          template: "vl_planejado_ac",
        },
        {
          prop: "vl_planejado_m2_ac",
          align: "right",
          label: "Planejado AC M2",
          type: "template",
          template: "vl_planejado_m2_ac",
        },
        {
          prop: "vl_pago_ac",
          align: "right",
          label: "Realizado AC",
          type: "template",
          template: "vl_pago_ac",
        },
        {
          prop: "vl_pago_m2_ac",
          align: "right",
          label: "Realizado M2 AC",
          type: "template",
          template: "vl_pago_m2_ac",
        },
        {
          prop: "vl_saldo_m2_ac",
          align: "right",
          label: "Saldo M2 AC",
          type: "template",
          template: "vl_saldo_m2_ac",
        },
        {
          prop: "vl_saldo_ac",
          align: "right",
          label: "Saldo AC",
          type: "template",
          template: "vl_saldo_ac",
        },
      ],
    };
  },
  methods: {
    getRowStyle(row) {
      if (row.children && row.children.length > 0) return { backgroundColor: "#efefef", borderColor: "#bbb" };

      return { borderColor: "#bbb" };
    },
    gerarAcumulados() {
      // limpar antes
      if (this.resumo == null) this.resumo = [];
      for (let index = 0; index < this.resumo.length; index++) {
        const element = this.resumo[index];
        element.vl_planejado_orig_ac = 0;
        element.vl_planejado_ac = 0;
        element.vl_pago_ac = 0;
        element.vl_saldo_ac = 0;

        element.vl_planejado_orig_m2_ac = 0;
        element.vl_planejado_m2_ac = 0;
        element.vl_pago_m2_ac = 0;
        element.vl_saldo_m2_ac = 0;
      }

      if (this.resumo.length > 0) {
        //acumulados
        let vl_planejado_orig_ac = parseFloat(0);
        let vl_planejado_ac = parseFloat(0);
        let vl_pago_ac = parseFloat(0);

        // moeda 2
        let vl_planejado_orig_m2_ac = parseFloat(0);
        let vl_planejado_m2_ac = parseFloat(0);
        let vl_pago_m2_ac = parseFloat(0);

        for (let index = 0; index < this.resumo.length; index++) {
          const element = this.resumo[index];
          vl_planejado_orig_ac += parseFloat(element.vl_planejado_orig);
          vl_planejado_ac += parseFloat(element.vl_planejado);
          vl_pago_ac += parseFloat(element.vl_pago);

          vl_planejado_orig_m2_ac += parseFloat(element.vl_planejado_orig_m2);
          vl_planejado_m2_ac += parseFloat(element.vl_planejado_m2);
          vl_pago_m2_ac += parseFloat(element.vl_pago_m2);

          element.vl_planejado_orig_ac = vl_planejado_orig_ac;
          element.vl_planejado_ac = vl_planejado_ac;
          element.vl_pago_ac = vl_pago_ac;
          element.vl_saldo_ac = vl_planejado_ac - vl_pago_ac;

          element.vl_planejado_orig_m2_ac = vl_planejado_orig_m2_ac;
          element.vl_planejado_m2_ac = vl_planejado_m2_ac;
          element.vl_pago_m2_ac = vl_pago_m2_ac;
          element.vl_saldo_m2_ac = vl_planejado_m2_ac - vl_pago_m2_ac;
        }
        this.makeTree();
      }
    },
    makeTree() {
      try {
        let tbl = document.querySelector("#tblWBSSintetico .zk-table__header thead");
        let tr = document.querySelector("#tr_cabecalho");
        if (tr) tr.remove();

        tr = document.createElement("tr");
        let th1 = document.createElement("th");
        let th2 = document.createElement("th");
        tr.id = "tr_cabecalho";
        tr.classList = "zk-table__header-row";
        th1.classList = "zk-table__header-cell zk-table--border-cell text-center";
        th2.classList = "zk-table__header-cell zk-table--border-cell text-center";
        th1.innerHTML = "PLANEJAMENTO/EXECUÇÃO";
        th1.colSpan = 6;

        th2.innerText = "ACUMULADO";
        th2.colSpan = 3;

        tr.appendChild(th1);
        tr.appendChild(th2);
        tbl.insertBefore(tr, tbl.firstChild);
      } catch (err) {
        console.log(err);
      }
    },
    buildTree(itemList, parentId) {
      let result = new Array();
      for (let index = 0; index < itemList.length; index++) {
        const element = itemList[index];
        if (element.parent_id == parentId) {
          let newItem = { ...element };
          if (newItem.children.length == 0) newItem.children = this.buildTree(itemList, newItem.wbs_id);
          result.push(newItem);
        }
      }

      if (result.length > 0) return result;
      return [];
    },
    getParentWBS(wbs) {
      let wbsid_exploded = wbs.split(".");

      let wbs_sliced = wbsid_exploded.slice(0, -1);

      let wbs_imploded = wbs_sliced.join(".");
      return wbsid_exploded.length == 1 ? "" : wbs_imploded;
    },
    showResumo() {
      this.resumo = [];
      axios
        .get(`${baseApiUrl}/bid/resumo-financeiro/listar`, {
          params: {
            programa_id: this.wbs.programa_id,
            wbs_id: this.wbs.wbs_id,
            sintetico: 1,
          },
        })
        .then((resp) => {
          if (!Array.isArray(resp.data)) this.resumo = [];
          else this.resumo = resp.data;

          this.gerarAcumulados();
        })
        .catch((ex) => {
          showError(ex);
        });
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if ((item.vl_pago || 0) > 0) return "table-success";
    },
  },
  created() {
    bidbus.$on("updateResumo", () => {
      this.showResumo();
    });
  },
  mounted() {
    this.showResumo();
  },
};
</script>

<style>
.top-header th {
  background-color: #4c545b !important;
  text-align: center;
  border-bottom: none !important;
}

.table-header th {
  border-color: #aaa !important;
}

.accum-col {
  background-color: #efefef;
}

.accum-col:hover {
  color: #333 !important;
}

.table-border td {
  border-color: #ccc !important;
}

.zk-table__body {
  border: 1px solid #bbb !important;
}
</style>
